<app-banner-message></app-banner-message>
<mat-sidenav-container fullscreen>
	<mat-sidenav
		class="column"
		[mode]="sidenavMode"
		[opened]="sidenavOpened"
		[disableClose]="!isMobile"
		[@.disabled]="!isMobile"
	>
		<div class="side-nav-flex">
			<!-- Mobile close button -->
			@if (isMobile) {
				<button class="mobile-nav-close-button" (click)="toggleSidenav()" data-automation-id="mobile-nav-close">
					<span class="close-icon" role="img" [title]="closeMenuText"></span>
				</button>
			}

			<div class="side-nav">
				<img class="side-nav-logo" src="assets/accessplus-dark.svg" alt="SentriKey® Access Logo" />

				<div class="side-nav-profile" (click)="showProfilePopout()" data-automation-id="show-profile-popout">
					<div class="side-nav-avatar-outer">
						<div class="side-nav-avatar">
							{{ userNameAbbreviation }}
						</div>
					</div>

					<div class="side-nav-user-name-container">
						<div class="side-nav-user-name" #userNameRef>
							<span class="side-nav-user-name-text">{{ userName }}</span>
							<mat-icon class="side-nav-user-name-arrow">arrow_drop_down</mat-icon>
						</div>

						<app-loading-indicator [keys]="[loadingChangeRoleKey]" diameter="30">
							<div class="mat-caption side-nav-user-company">
								{{ assignedRole?.entityRelationship?.parentEntity?.name }}
							</div>
							<div class="mat-caption side-nav-user-role">{{ assignedRole?.role?.name }}</div>
						</app-loading-indicator>
					</div>
				</div>
			</div>

			<mat-divider class="side-nav-divider"></mat-divider>

			<mat-nav-list class="nav-list">
				@for (item of menuItems; track item.type) {
					<a
						mat-list-item
						[routerLink]="item.link"
						[queryParams]="item.subtabIndex !== undefined ? { tabIndex: item.subtabIndex } : undefined"
						[class]="{ 'active-nav-item': item.type === lastSelectedNavItem }"
						(click)="navItemClicked(item)"
						[attr.data-automation-id]="'nav-item-' + navItemAutomationIds[item.type] + '-link'"
					>
						<div class="nav-item-container">
							<mat-icon class="menu-item-icon" [svgIcon]="item.icon"></mat-icon>
							<span class="nav-menu-text" [class]="{ 'font-weight-bold': item.type === lastSelectedNavItem }">{{
								item.title
							}}</span>
						</div>
					</a>
				}
			</mat-nav-list>

			<div class="side-nav-footer">
				@if (canIssueFlexCodes) {
					<div class="side-nav-gen-code-right-container">
						<button
							mat-button
							class="primary-button gen-code-button"
							(click)="onGenerateCodeClick()"
							data-automation-id="nav-generate-code-button"
						>
							<div class="gen-code-button-container">
								<span class="plus-icon" [title]="generateCodeIconText"></span>
								<span i18n="@@deviceGenerateOneDayCode-generateCode">Generate Code</span>
							</div>
						</button>
					</div>
				}

				<div class="side-nav-copy-right-container">
					@if ((loadingService.isLoading() && isMobile) || !isMobile) {
						<div class="loading-indicator-container">
							@if (!isMobile) {
								<app-loading-indicator
									[boxStyle]="{ width: '35px', 'margin-left': '4px' }"
									diameter="30"
								></app-loading-indicator>
							}
							@if (isMobile) {
								<app-loading-indicator
									[boxStyle]="{ width: '35px', 'margin-left': '4px' }"
									diameter="25"
								></app-loading-indicator>
							}
						</div>
					}
					<div class="side-nav-copy-right mat-caption">&copy; 2026 Keynetics</div>
				</div>
			</div>
		</div>
	</mat-sidenav>

	<mat-sidenav-content>
		<div class="main-content">
			<!-- Mobile menu toggle button visible for screens smaller than landscape mode of 992 px -->
			@if (isMobile) {
				<button class="mobile-menu-toggle" (click)="toggleSidenav()" data-automation-id="mobile-menu-toggle">
					<span class="right-caret-icon" role="img" [title]="openMenuText"></span>
				</button>
			}
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
